export default {
  umlaufInfoByTourHash: {}, // compiled data from perlschnur json files (because not stored on database but used for searching, mainly Umlauf Nr.)

  perlschnurJsonByTourHash: {}, //{tourHash}.json perlschnur json files by tour hash
  timetable: [], //fahrdienst452_timetable
  timetableByTourHash:{},
  // Used with normalized vdv-data (non perlschnur.json approach)
  fahrt: [],
  fahrtBy_day_by_kurs: {},
  fahrtBy_day_by_adapterUmlauf: {},
  verlaufByAdapterLinieId: {},
  fahrt_lists_by_day_adapterUmlauf: {},
  ortById: {},
  haltezeitBy_fahrtId_ortId: {},
  haltezeitenFahrtgruppeBy_adapterId_ortId: {},
  fahrzeitBy_adapter_fgrNr_startOrtIdFk_endOrtIdFk: {},
  fahrtAnschlussBy_fahrtId_ortId: {},

  fahrzeitBy_startOrtShortName_endOrtShortName: {},
  haltezeitBy_fahrtId_ortShortName: {},
  fahrzeitBy_startOrtIdFk_endOrtIdFk: {},
  verlaufByAdapterId: {},

  fahrdienst452LinesByKuerzel:{},
  fahrdienst452LinesByLine:{}
};
